import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { useApp } from '@/store/app';
import { TOOLS } from '@/registry';
import { ToolCard } from '@/components/ToolCard';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import type { Tool } from '@/registry/types';

export function FavoritesView() {
  const { favorites } = useApp();
  const navigate = useNavigate();
  const tools = favorites
    .map((id) => TOOLS.find((t) => t.id === id))
    .filter((t): t is Tool => Boolean(t));

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-6 md:py-10">
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <Star size={14} className="text-warning fill-warning" />
          <h2 className="text-sm font-semibold uppercase tracking-wider text-fg-subtle">
            Favorites
          </h2>
        </div>
        <h1 className="text-3xl font-semibold tracking-tight mt-1">Your shortcuts</h1>
      </div>

      {tools.length === 0 ? (
        <EmptyState
          icon={<Star size={20} />}
          title="No favorites yet"
          description="Star tools you use often for quick access."
          action={
            <Button variant="primary" onClick={() => navigate('/')}>
              Browse utilities
            </Button>
          }
        />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {tools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      )}
    </div>
  );
}
